export const CLASSES_SALES_FILTER_IDS = ['venue_ownership_id', 'class_template_id', 'status'];

export const CLASSES_REGISTRATIONS_FILTER_IDS = ['venue_ownership_id', 'class_instance_id', 'status', 'registration_type'];

const venueGroup = (venueOwnerships) => ({
  id: 'venue',
  label: 'Venue',
  filters: [
    {
      id: 'venue_ownership_id',
      label: 'Venue',
      type: 'checkbox',
      options: (venueOwnerships || []).map(o => ({ value: String(o.id), label: o.name })),
    },
  ],
});

export const buildClassesSalesFilterGroups = (filterOptions = {}, venueOwnerships = []) => [
  venueGroup(venueOwnerships),
  {
    id: 'class',
    label: 'Class',
    filters: [
      { id: 'class_template_id', label: 'Template', type: 'checkbox', options: filterOptions.template_options || [] },
      { id: 'status', label: 'Status', type: 'checkbox', options: filterOptions.status_options || [] },
    ],
  },
];

export const buildClassesRegistrationsFilterGroups = (filterOptions = {}, venueOwnerships = []) => [
  venueGroup(venueOwnerships),
  {
    id: 'registration',
    label: 'Registration',
    filters: [
      { id: 'class_instance_id', label: 'Class', type: 'checkbox', options: filterOptions.class_options || [] },
      { id: 'status', label: 'Status', type: 'checkbox', options: filterOptions.status_options || [] },
      { id: 'registration_type', label: 'Type', type: 'checkbox', options: filterOptions.registration_type_options || [] },
    ],
  },
];

export const pickFilterParams = (filterIds) => (activeFilters) => {
  const params = {};
  filterIds.forEach((id) => {
    if (activeFilters[id]?.length) params[id] = activeFilters[id];
  });
  return params;
};
